import { ocrRolloverAmountOptions } from '../../flows/front-office/shared/utils';

export const disableRolloverAmtInput = rolloverAmountOption =>
  rolloverAmountOption === ocrRolloverAmountOptions.ALL;

export const disableEditBtn = (isValid, error) => !isValid || error !== '';

const isCartValid = (validCart, isValidTotal, isExistingAgreementNotchosen) =>
  validCart && isValidTotal && !isExistingAgreementNotchosen;

const checkExceedsFlag = (exceedsMaxBalance, exceedsPercentage) =>
  exceedsMaxBalance || exceedsPercentage;

const validatePortfolioEditMode = (
  selectedFunds,
  validCart,
  isValidTotal,
  rolloverAmount,
  exceedsMaxBalance,
  exceedsPercentage,
  isExistingAgreementNotchosen
) => {
  if (
    selectedFunds.length > 0 &&
    rolloverAmount >= 1000 &&
    !checkExceedsFlag(exceedsMaxBalance, exceedsPercentage) &&
    isCartValid(validCart, isValidTotal, isExistingAgreementNotchosen)
  ) {
    return true;
  }
  return false;
};

export const shouldValidate = (
  selectedFunds,
  editPortfolio,
  validCart,
  isValidTotal,
  portfolioValid,
  rolloverAmount,
  exceedsMaxBalance,
  exceedsPercentage,
  isExistingAgreementNotchosen
) => {
  if (editPortfolio) {
    return validatePortfolioEditMode(
      selectedFunds,
      validCart,
      isValidTotal,
      rolloverAmount,
      exceedsMaxBalance,
      exceedsPercentage,
      isExistingAgreementNotchosen
    );
  }
  if (selectedFunds.length > 0 && portfolioValid) {
    return true;
  }
  return false;
};

export const combineAgreements = (
  existingAgreements,
  existingRPSAgreements
) => {
  // combine rps and II existing agreements if funds for both type are present
  if (existingRPSAgreements?.length > 0 && existingAgreements?.length > 0) {
    return existingAgreements?.concat(existingRPSAgreements);
    // return rps agreement only when II existing agreements is not present but matching rps agreements are present
  }
  if (existingRPSAgreements?.length > 0 && existingAgreements?.length === 0) {
    return existingRPSAgreements;
  }
  // default return existing II agreements array
  return existingAgreements;
};

export const checkExistingAgreements = (existingAgreementsArr, fundsInCart) => {
  const matchingTickers = [];
  // eslint-disable-next-line chai-friendly/no-unused-expressions
  existingAgreementsArr?.length > 0 &&
    // eslint-disable-next-line array-callback-return
    existingAgreementsArr?.some(({ ticker }) => {
      // eslint-disable-next-line array-callback-return
      fundsInCart.find(fundIncart => {
        if (fundIncart.ticker === ticker) {
          matchingTickers.push(ticker);
        }
      });
    });
  return matchingTickers;
};

export const defaultRolloverAmt = (
  rolloverAmount,
  shouldDisableRolloverAmtInput
) => {
  if (shouldDisableRolloverAmtInput || rolloverAmount === 0) {
    return '';
  }
  return rolloverAmount;
};
